import React from 'react';
import { Github, Slack, Trello, Figma, Plus } from 'lucide-react';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
export function IntegrationsPage() {
  const integrations = [{
    id: 'github',
    name: 'GitHub',
    icon: Github,
    status: 'connected',
    details: '3 repos linked'
  }, {
    id: 'slack',
    name: 'Slack',
    icon: Slack,
    status: 'not_connected',
    details: 'Connect for notifications'
  }, {
    id: 'jira',
    name: 'Jira',
    icon: Trello,
    status: 'connected',
    details: 'Project: DNS-OPT'
  }, {
    id: 'figma',
    name: 'Figma',
    icon: Figma,
    status: 'not_connected',
    details: 'Sync designs'
  }];
  return <div className="p-8 max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-text-primary mb-2">Integrations</h1>
        <p className="text-text-secondary">
          Connect your tools to sync work automatically
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {integrations.map(integration => <div key={integration.id} className="bg-surface-800 border border-surface-500 rounded-xl p-6 flex flex-col">
            <div className="flex items-start justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-surface-900 flex items-center justify-center border border-surface-500">
                <integration.icon className="w-6 h-6 text-text-primary" />
              </div>
              <Badge variant={integration.status === 'connected' ? 'success' : 'secondary'}>
                {integration.status === 'connected' ? 'Connected' : 'Not Connected'}
              </Badge>
            </div>

            <h3 className="text-lg font-semibold text-text-primary mb-1">
              {integration.name}
            </h3>
            <p className="text-sm text-text-secondary mb-6">{integration.details}</p>

            <div className="mt-auto">
              <Button variant={integration.status === 'connected' ? 'secondary' : 'primary'} className="w-full">
                {integration.status === 'connected' ? 'Configure' : 'Connect'}
              </Button>
            </div>
          </div>)}

        {/* Add Custom */}
        <button className="bg-surface-900/50 border-2 border-dashed border-surface-600 rounded-xl p-6 flex flex-col items-center justify-center text-text-muted hover:text-text-primary hover:border-surface-500 hover:bg-surface-900 transition-all group">
          <div className="w-12 h-12 rounded-full bg-surface-800 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
            <Plus className="w-6 h-6" />
          </div>
          <span className="font-medium">Add Custom Integration</span>
          <span className="text-sm opacity-60 mt-1">Webhooks & API</span>
        </button>
      </div>
    </div>;
}